<script setup>
import { format } from 'date-fns';
import {computed} from "vue";
import {BIcon} from "buefy";
import {getDateLocale} from "@/utils/locale.js";
import {useI18n} from "vue-i18n";

const i18n = useI18n();

const props = defineProps({
    training: Object
})

const formattedDates = computed(() => {
    return props.training.enrollments?.map(enrollment => {
        if (!enrollment.training_date) {
            return null;
        }
        const d = new Date(enrollment.training_date.starts_at);
        return format(d, "d MMMM yyyy, HH:mm", { locale: getDateLocale(i18n.locale.value) });
    }).filter(d => !!d)
})
</script>

<template>
        <div class="tag is-success mb-2" v-for="formattedDate in formattedDates || []">
            <BIcon icon="calendar-check" size="is-small"/> <span class="ml-1">{{ formattedDate }}</span>
        </div>
</template>
